import React from "react";
import { Link } from "react-router-dom";

// IMPORTAR ICONOS
import webIcon from "../assets/images/icon/web.png";
import cmsIcon from "../assets/images/icon/cms.png";
import ecommerceIcon from "../assets/images/icon/ecommerce.png";
import iaIcon from "../assets/images/icon/ia.png";
import marketingIcon from "../assets/images/icon/marketing.png";
import optimizacionIcon from "../assets/images/icon/optimizacion.png";

const services = [
  {
    icon: webIcon,
    title: "Desarrollo Web & App",
    description:
      "Rápidos y responsivos con React, Next.js y tecnologías modernas.",
    link: "/desarrollo-web"
  },
  {
    icon: cmsIcon,
    title: "CMS y Contenidos",
    description:
      "WordPress, Elementor y Avada para gestionar tu web de forma simple.",
    link: "/cms"
  },
  {
    icon: ecommerceIcon,
    title: "E-Commerce",
    description:
      "Tiendas online con WooCommerce y PrestaShop optimizadas para vender.",
    link: "/ecommerce"
  },
  {
    icon: iaIcon,
    title: "Inteligencia Artificial",
    description:
      "Chatbots y automatización para mejorar tu negocio.",
    link: "/inteligencia-artificial"
  },
  {
    icon: marketingIcon,
    title: "Marketing Digital",
    description:
      "SEO, Ads y estrategias para generar clientes y ventas.",
    link: "/marketing-digital"
  },
  {
    icon: optimizacionIcon,
    title: "Optimización Web",
    description:
      "Velocidad, SEO técnico y rendimiento.",
    link: "/optimizacion-web"
  }
];

export default function Services() {
  return (
    <section className="services-section text-center">
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-md-4 col-sm-6">
              <Link to={service.link} className="service-card-link">
                <div className="service-card">
                  
                  <div className="icon">
                    <img
                      src={service.icon}
                      alt={service.title}
                      className="service-icon"
                    />
                  </div>

                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}